export enum TextAlign {
    Start = 'start',
    Center = 'center',
    Justify = 'justify',
    End = 'end'
}
